import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TimeRange } from 'apps/webapp/src/app/@core/data/recruitment';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'previous-work-activities',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        SelectModule,
        InputTextModule,
        DatePickerModule,
        TooltipModule,
        CheckboxModule,
    ],
    templateUrl: './previous-work-activities.component.html',
    styleUrls: ['./previous-work-activities.component.scss'],
    standalone: true,
})
export class PreviousWorkActivitiesComponent implements OnInit {
    @Input() form: FormGroup;

    translate = inject(TranslateService);

    timeRangeOptions = [
        {
            label: this.translate.instant('selfservice-request.previous-work-activities.time-range.last-6-months'),
            value: TimeRange.LAST_6_MONTHS,
        },
        {
            label: this.translate.instant('selfservice-request.previous-work-activities.time-range.last-24-months'),
            value: TimeRange.LAST_24_MONTHS,
        },
        {
            label: this.translate.instant('selfservice-request.previous-work-activities.time-range.none'),
            value: TimeRange.NONE,
        },
    ];

    yesNoOptions = [
        { label: this.translate.instant('selfservice-request.previous-work-activities.yes-no.yes'), value: true },
        { label: this.translate.instant('selfservice-request.previous-work-activities.yes-no.no'), value: false },
    ];

    constructor() { }

    ngOnInit(): void { }
}
